// Provides a resilient dynamic import with one-time reload on ChunkLoadError
// and optional stable webpackChunkName via passed importer.

function shouldRetry(error) {
  if (!error) return false;
  const name = String(error.name || '');
  const message = String(error.message || '');
  return name === 'ChunkLoadError' || /Loading chunk \d+ failed/i.test(message);
}

function markReloadedFlag(flagKey) {
  try { sessionStorage.setItem(flagKey, 'true'); } catch (_) {}
}

function wasReloaded(flagKey) {
  try { return sessionStorage.getItem(flagKey) === 'true'; } catch (_) { return false; }
}

export default async function safeDynamicImport(importer, flagName = 'chunk_reloaded_once') {
  try {
    return await importer();
  } catch (error) {
    if (shouldRetry(error) && !wasReloaded(flagName)) {
      try { console.warn('[safeDynamicImport] Retrying after chunk error:', error); } catch (_) {}
      markReloadedFlag(flagName);
      // Force a hard reload so the new manifest/chunk map is used
      window.location.reload();
      // Return a never-resolving promise to halt further execution
      return new Promise(() => {});
    }
    throw error;
  }
}


